<template>
  <!-- Bottom Sheet Overlay -->
  <div 
    v-if="showBottomSheet"
    class="fixed inset-0 bg-[#0B0C0E] z-50 flex items-end justify-center"
    @click="closeBottomSheet"
    dir="ltr"
  >
    <!-- Bottom Sheet Content -->
    <div 
      class="bg-[#14151A] rounded-t-3xl w-full max-w-md mx-auto p-6 transform transition-transform duration-300 ease-out"
      :class="{ 'translate-y-0': showBottomSheet, 'translate-y-full': !showBottomSheet }"
      @click.stop
      dir=""
    >
      <!-- Close Button -->
      <button 
        @click="closeBottomSheet"
        class="absolute top-4 right-4 text-gray-400 hover:text-white"
      
      >
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>

      <!-- Handle Bar -->
      <div class="w-12 h-1 bg-gray-600 rounded-full mx-auto mb-6"></div>

      <!-- Content -->
      <div class="text-center">
        <h2 class="text-xl font-bold text-white mb-2 font-Almarai">
          تابع استخدام ناسنا على
        </h2>
        <p class="text-gray-300 text-sm mb-6 font-Almarai">
          للحصول على أفضل تجربة مشاهدة، ننصح بالمتابعة في التطبيق
        </p>

        <!-- Buttons -->
        <div class="space-y-3">
          <button
            @click="openApp"
            class="w-full bg-[#9d2890] hover:bg-[#8a2279] text-white font-semibold py-4 px-6 rounded-xl transition-colors duration-200 font-Almarai"
          >
            فتح التطبيق
          </button>
          <button
            @click="continueOnWeb"
            class="w-full border border-gray-600 hover:border-gray-500 text-gray-200 hover:text-white font-semibold py-4 px-6 rounded-xl transition-colors duration-200 font-Almarai"
          >
            متابعة على الويب
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PaymentCallback",
  data() {
    return {
      showBottomSheet: false,
    };
  },
  methods: {
    openBottomSheet() {
      this.showBottomSheet = true;
    },
    closeBottomSheet() {
      this.showBottomSheet = false;
    },
    openApp() {
     
      window.location.href = "https://nasna.tv/watch/subscription-sync";
      this.closeBottomSheet();
    },
    continueOnWeb() {
    
      this.$router.push({ name: "home" });
      this.closeBottomSheet();
    },
  },
  props: {
    autoShow: {
      type: Boolean,
      default: true
    }
  },
  
  created() {
    // Get all query parameters for debugging
    console.log("Payment callback query parameters:", this.$route.query);
    console.log("ContinueApp autoShow prop:", this.autoShow);
    
    // Show bottom sheet automatically only if autoShow is true
    if (this.autoShow) {
      setTimeout(() => {
        this.openBottomSheet();
      }, 500);
    }
  }
};
</script>

<style scoped>
/* Bottom sheet animation */
.transform {
  transition: transform 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

/* Backdrop blur effect for better visual separation */
.bg-opacity-50 {
  backdrop-filter: blur(4px);
}

/* Button hover effects */
button:hover {
  transform: translateY(-1px);
}

button:active {
  transform: translateY(0);
}

/* Smooth transitions for all interactive elements */
button {
  transition: all 0.2s ease-in-out;
}
</style>
